import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { ActiveState } from 'src/sb-tools/typescript/services/active-state.service';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { environment } from '@environment';
import { CommunityUser } from '@sb-tools/typescript/models/community-user.model';
import { UserRole } from '@sb-tools/typescript/enums/user-role.enum';
import { TranslateModule } from '@ngx-translate/core';
import { UserAvatarComponent } from '../Frontend-User-Avatar-Module/user-avatar.component';
import { NgClass } from '@angular/common';
import { TruncatePipe } from '@sb-tools/typescript/pipes/truncate.pipe';

@Component({
    selector: 'sb-settings-menu',
    templateUrl: './settings-menu.component.html',
    styleUrls: ['./settings-menu.component.scss'],
    imports: [TranslateModule, UserAvatarComponent, NgClass, TruncatePipe, BsDropdownModule],
})
export class SettingsMenuComponent implements OnChanges {
    @Input() communityName?: string;
    @Input() customerSettings?;
    @Input() language?: string;
    @Input() user: CommunityUser;

    @Output() logout: EventEmitter<any> = new EventEmitter();

    @ViewChild('dropdown') private dropdown: BsDropdownDirective;

    environment = environment;
    personalSettingsUrl: string;
    settingsUrl: string;

    constructor(public activeState: ActiveState) {}

    ngOnChanges(): void {
        this.personalSettingsUrl = environment.settingsUrl + this.communityName + '/user/settings/general';
        this.settingsUrl =
            this.user?.role === UserRole.manager
                ? environment.settingsUrl + this.communityName + '/community/tags'
                : environment.settingsUrl + this.communityName + '/community/settings/general';
    }
}
